import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, Validators, FormGroup } from "@angular/forms";

@Component({
    selector: 'invitation-manager',
    template: `
    <mat-card [formGroup]="form">
        <mat-card-title>{{title}}</mat-card-title>
        <mat-card-content>
            <mat-card formArrayName="invitations">
                <ng-container *ngFor="let invitation of invitationGroups.controls; index as i; last as isLast " [formGroupName]="i">
                <mat-card-content fxLayout.xs="column">
                    <mat-form-field fxFlex="45" fxFlex.xs="100" style="padding-top: 14px;">
                        <input matInput placeholder="EmailAddress" formControlName="emailAddress">
                        <mat-error *ngIf="invitation.get('emailAddress').hasError('required')">Email Address is required.</mat-error>
                        <mat-error *ngIf="invitation.get('emailAddress')?.hasError('pattern')">Email address must be valid.</mat-error>
                    </mat-form-field>
                    <div fxLayout="row" fxFlex="50" fxFlexOffset.gt-xs="5" fxFlex.xs="100">
                        <mat-form-field fxFlex="100">
                            <textarea matInput placeholder="Invitation Message" formControlName="message"></textarea>
                        </mat-form-field>
                        <button *ngIf="invitationGroups.controls.length !== 1" 
                                mat-icon-button
                                (click)="removeInvitationGroup(i)"
                                style="padding-top: 25px;"><mat-icon>close</mat-icon></button>
                    </div>
                </mat-card-content>
                <mat-card-actions *ngIf="isLast">
                    <button mat-button (click)="addInvitationGroup()" [disabled]="form.invalid">Invite More</button>
                </mat-card-actions>
                </ng-container>
            </mat-card>
        </mat-card-content>
        <mat-card-actions>
            <ng-content></ng-content>                
        </mat-card-actions>
    </mat-card>
    `
})
export class InvitationManagerComponent implements OnInit {
    @Input() title: string;
    @Input() form: FormGroup; 
    
    constructor(private fb: FormBuilder) {}

    ngOnInit(): void {
        this.form.addControl('invitations', this.fb.array([this.createInvitationGroup()]));
    }

    addInvitationGroup = () => (<FormArray>this.form.get('invitations')).push(this.createInvitationGroup());

    removeInvitationGroup = (i) => this.invitationGroups.removeAt(i);

    createInvitationGroup = () =>  this.fb.group({
        emailAddress: this.fb.control('', [Validators.required, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$')]),
        message: this.fb.control(''),
        isClient: this.fb.control(true)
    })

    get invitationGroups (): FormArray {
        return <FormArray>this.form.get('invitations');
    }
}